import React from "react";

import center from "../../assets/images/selfcenter/center.png";
import FeatureBox from "../Common/FeatureBox";

const Features = () => {
  const features = [
    {
      icon: "monitor",
      title: " 个人信息与修改",
      desc:
        "员工可在个人中心完善及修改个人信息，管理员审核之后自动更新人事档案信息",
    },
    {
      icon: "feather",
      title: " 流程及待办",
      desc:
        "处理流程审批、绩效考评、个人薪酬确认等待办信息，同时待办信息可与钉钉、企业微信等第三方系统集成。",
    },
    {
      icon: "eye",
      title: " 我的考勤",
      desc:
        "员工实时收到关于考勤异常的通知，在个人中心发起请假、补卡、加班等考勤业务流程",
    },
    {
      icon: "user-check",
      title: " 薪酬数据",
      desc: "员工可以每月进行薪酬的确认并查看个人历史薪酬数据与社保缴纳情况",
    },
    {
      icon: "user-check",
      title: "绩效考评",
      desc:
        "用户进行自评、绩效打分、绩效申述等绩效任务办理，同时也可以查询个人历史绩效得分或等级的情况",
    },
  ];
  return (
    <section className="section bg-light">
      <div className="container">
        <div className="row">
          <div className="section-title ma">
            <h2>核心功能</h2>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col col-lg-7 col-md-7 text-center">
            <img
              src={center}
              className="img-fluid shadow rounded"
              alt="hr软件员工个人中心"
            />
          </div>
          <div className="col col-lg-4 col-md-4 ml-4">
            <div className="row">
              <FeatureBox data={features} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
